import { render, staticRenderFns } from "./RenewalDashboardFilterModal.vue?vue&type=template&id=2196363e&scoped=true"
import script from "./RenewalDashboardFilterModal.vue?vue&type=script&lang=js"
export * from "./RenewalDashboardFilterModal.vue?vue&type=script&lang=js"
import style0 from "./RenewalDashboardFilterModal.vue?vue&type=style&index=0&id=2196363e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196363e",
  null
  
)

export default component.exports